<template>
  <v-card>
      <v-card-title>
        HISTORIAL DE CAMBIOS
        <v-spacer/>
        <v-btn
            icon
            @click="$emit('close')"
        >
          X
        </v-btn>
      </v-card-title>
    <v-card-subtitle>Nro: {{ factura.numero_factura }} - nfac: {{ factura.nfac }}</v-card-subtitle>
      <v-divider/>
      <v-card-text>
        <v-data-table
            :headers="headers"
            :items="historiales"
            class="mt-5"
            hide-default-footer
            disable-pagination
        >
          <template v-slot:item.fecha="props">
            {{ props.item.fecha | localDateHour }}
          </template>
        </v-data-table>
      </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";
import {recaudacionStore} from "@/store/recaudacionStore";
@Component({
  name: "FacturaHistorial"
})
export default class extends Vue {
  @Prop() factura!: any
  private recaudacionStore = recaudacionStore();

  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  get historiales(): any[] {
    return this.recaudacionStore.historiales;
  }

}
</script>

<style scoped>

</style>